<app-page-title title="Alım/Satım Kar Raporu"></app-page-title>

<div class="card">
  <div class="card-body">
    <div class="card-title d-flex justify-content-between">
      <h5>Filtrele <i class="fas fa-search"></i></h5>
      <button class="btn btn-sm btn-outline-info" triggers="hover" ngbTooltip="Filtreyi Temizle" placement="auto"
        container="body" (click)="clearFilter()"><i class="fas fa-trash-alt"></i></button>
    </div>
    <div class="row pt-2">
      <div class="col-md-6 col-lg-2 mb-3">
        <div class="input-group">
          <input placeholder="Başlangıç Tarihi" (click)="beginDate.toggle()" class="form-control"
            name="beginDatePicker" [(ngModel)]="beginDateModel" (ngModelChange)="onBeginDateChange($event)" ngbDatepicker
            #beginDate="ngbDatepicker" autocomplete="off">
          <button class="btn border-start-0" style="border-color: #ced4da;" (click)="beginDate.toggle()"
            type="button"> <i class="far fa-calendar"></i> </button>
        </div>
      </div>
      <div class="col-md-6 col-lg-2 mb-3">
        <div class="input-group">
          <input placeholder="Bitiş Tarihi" (click)="endDate.toggle()" class="form-control" name="endDatePicker"
            [(ngModel)]="endDateModel" (ngModelChange)="onEndDateChange($event)" ngbDatepicker #endDate="ngbDatepicker"
            autocomplete="off">
          <span class="input-group-append">
            <button class="btn border-start-0" style="border-color: #ced4da;" (click)="endDate.toggle()"><i
                class="far fa-calendar-alt"></i></button>
          </span>
        </div>
      </div>
      <div class="col-md-6 col-lg-2 mb-3">
        <select [(ngModel)]="filter.paymentCurrency" (change)="onPaymentCurrencyChanged()"
          class="form-control">
          <option [ngValue]="defaultValue">Satılan Birim</option>
          <option *ngFor="let item of currencyList" [ngValue]="item">{{item | customCurrency }}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-2 mb-3" *ngIf="paymentSubTypes && paymentSubTypes.length > 0">
        <select [(ngModel)]="filter.paymentSubType" class="form-control">
          <option [ngValue]="defaultValue">Alt Birim</option>
          <option *ngFor="let item of paymentSubTypes" [ngValue]="item">{{item | subTypeDisplay}}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-2 mb-3">
        <button class="btn btn-primary w-100" (click)="generateReport()" [disabled]="isLoading">
          <span *ngIf="!isLoading"><i class="fas fa-search"></i> Rapor Oluştur</span>
          <span *ngIf="isLoading"><i class="fas fa-spinner fa-spin"></i> Yükleniyor...</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" *ngIf="profitReport">
  <div class="card-body">
    <div class="card-title d-flex justify-content-between">
      <h5>Kar Raporu Özeti</h5>
      <button class="btn btn-sm btn-outline-success" (click)="exportToExcel()" title="Excel'e Aktar">
        <i class="fas fa-file-excel"></i> Dışa Aktar
      </button>
    </div>

    <p class="text-muted small mb-3">
      <i class="fas fa-info-circle"></i> Kayıt birimi <b>has altın</b>: alınan şeyin maliyeti, onun için verilen
      şeydir. Kâr döviz elden çıkarken gerçekleşir ve satılan birim altında gösterilir. Alışta kâr oluşmaz.
      TL ve USD sütunları, has kârının <b>işlem günündeki</b> kurla çevrilmiş karşılığıdır.
    </p>
    <p class="text-muted small mb-3">
      <i class="fas fa-exchange-alt"></i> <b>İşlem farkı</b> kâr değildir: uygulanan kurun günün kurundan sapmasıdır.
      Piyasanın altında alım ya da üstünde satış buraya yazılır.
    </p>
    <p class="text-muted small mb-3" *ngIf="profitReport.currentHasToTL">
      Bugünkü kurla karşılığı:
      <b>{{ profitReport.totalProfitHAS * profitReport.currentHasToTL | number: '1.2-2' }}</b> TL
      <span *ngIf="profitReport.currentHasToUSD">
        · <b>{{ profitReport.totalProfitHAS * profitReport.currentHasToUSD | number: '1.2-2' }}</b> USD
      </span>
      <small>(1 gram has = {{ profitReport.currentHasToTL | number: '1.2-2' }} TL)</small>
    </p>
    <div class="alert alert-warning" *ngIf="profitReport.unprocessedCount > 0">
      <i class="fas fa-exclamation-triangle"></i> Bu aralıkta maliyeti henüz yeni yöntemle hesaplanmamış
      <b>{{ profitReport.unprocessedCount }}</b> işlem var; kârları toplamlara dahil değil.
      Alım/Satım Maliyetleri ekranındaki <b>Yeniden Hesapla</b> düğmesiyle güncelleyin.
    </div>

    <div class="row mb-4">
      <div class="col-md-3">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-title">Toplam İşlem</h6>
            <h3 class="text-primary">{{ profitReport.totalTransactions }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-title">Toplam Kar (TL)</h6>
            <h3 [ngClass]="profitReport.totalProfitTL >= 0 ? 'text-success' : 'text-danger'">
              {{ profitReport.totalProfitTL | number: '1.2-2' }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-title">Toplam Kar (USD)</h6>
            <h3 [ngClass]="profitReport.totalProfitUSD >= 0 ? 'text-success' : 'text-danger'">
              {{ profitReport.totalProfitUSD | number: '1.2-2' }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-title">Toplam Kar (HAS)</h6>
            <h3 [ngClass]="profitReport.totalProfitHAS >= 0 ? 'text-success' : 'text-danger'">
              {{ profitReport.totalProfitHAS | number: '1.3-3' }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-title">İşlem Farkı (HAS)</h6>
            <h3 [ngClass]="profitReport.totalMarketDifferenceHAS >= 0 ? 'text-success' : 'text-danger'">
              {{ profitReport.totalMarketDifferenceHAS | number: '1.3-3' }}
            </h3>
            <small class="text-muted">Kâr değildir; kurun piyasadan sapması.</small>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <thead class="table-dark">
          <tr>
            <th>Satılan Birim</th>
            <th class="text-end">İşlem Sayısı</th>
            <th class="text-end">Satılan Miktar</th>
            <th class="text-end">Kar (TL)</th>
            <th class="text-end">Kar (USD)</th>
            <th class="text-end">Kar (HAS)</th>
            <th class="text-end">İşlem Farkı (HAS)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of profitReport.profitByPaymentCurrency">
            <td>{{ item.paymentCurrency | customCurrency }} <span *ngIf="item.paymentSubType" class="badge bg-secondary">{{ item.paymentSubType | subTypeDisplay }}</span></td>
            <td class="text-end">{{ item.count }}</td>
            <td class="text-end">{{ item.totalAmount | number: '1.3-3' }}</td>
            <td class="text-end" [ngClass]="item.profitTL >= 0 ? 'text-success' : 'text-danger'">
              {{ item.profitTL | number: '1.2-2' }}
            </td>
            <td class="text-end" [ngClass]="item.profitUSD >= 0 ? 'text-success' : 'text-danger'">
              {{ item.profitUSD | number: '1.2-2' }}
            </td>
            <td class="text-end" [ngClass]="item.profitHAS >= 0 ? 'text-success' : 'text-danger'">
              {{ item.profitHAS | number: '1.3-3' }}
            </td>
            <td class="text-end" [ngClass]="item.marketDifferenceHAS >= 0 ? 'text-success' : 'text-danger'">
              {{ item.marketDifferenceHAS | number: '1.3-3' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="alert alert-info" *ngIf="!profitReport && !isLoading">
  <i class="fas fa-info-circle"></i> Rapor oluşturmak için filtreleri belirleyip "Rapor Oluştur" butonuna tıklayınız.
</div>
